'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'LearningCenterUI/components/I18n';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import H7 from 'UIComponents/elements/headings/H7';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import H5 from 'UIComponents/elements/headings/H5';
import Small from 'UIComponents/elements/Small';
import UICloseButton from 'UIComponents/button/UICloseButton';
import HR from 'UIComponents/elements/HR';
const BASE_18N_KEY = 'learningCenter.practicalExercise';

const PracticalExerciseInstructionsCompact = ({
  closeInstructions,
  description = '',
  isGraded,
  isManuallyApproved
}) => {
  const splitText = description.split(/\r?\n/).filter(Boolean);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsx(H5, {
        style: {
          fontWeight: 'normal'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_18N_KEY}.instructions.title`
        })
      }), /*#__PURE__*/_jsx(UICloseButton, {
        color: CALYPSO_DARK,
        onClick: closeInstructions,
        size: "small"
      })]
    }), /*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      children: /*#__PURE__*/_jsx(UIIllustration, {
        name: "building"
      })
    }), /*#__PURE__*/_jsx("p", {}), isGraded && /*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_18N_KEY}.instructionsPopOver.required`
      })
    }), /*#__PURE__*/_jsx(Small, {
      children: splitText.map((line, index) => /*#__PURE__*/_jsx("p", {
        children: line
      }, index))
    }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsxs(Small, {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${BASE_18N_KEY}.instructionsPopOver.start`
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_18N_KEY}.instructionsPopOver.${isManuallyApproved ? 'submitManual' : 'submitAutomatic'}`
        })
      })]
    })]
  });
};

PracticalExerciseInstructionsCompact.propTypes = {
  closeInstructions: PropTypes.func,
  description: PropTypes.string,
  isGraded: PropTypes.bool,
  isManuallyApproved: PropTypes.bool
};
export default PracticalExerciseInstructionsCompact;